import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const Popup = (props) => {
  const updateStatus = () => {
    axios
      .put(`${process.env.REACT_APP_API_URL}/jobPost/status`, {
        id: props.item._id,
        isEnabled: !props.item.isEnabled,
      })
      .then((res) => {
        props.handleClose(true, res.data.message);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        props.handleClose( 
          false,
          err && err.response && err.response.data && err.response.data.message
            ? err.data.response.message
            : err.message
        ); 
      });
  };
  const open = true;
  return (
    <>
      <Dialog onClose={props.handleClose} open={open}>
        <DialogTitle>Status Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {!props.item.isEnabled
              ? 'Are you sure you want to Enable the Job post ?'
              : 'Are you sure you want to Disable the Job post ? '}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
          <Button onClick={updateStatus}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Popup;
